import { IntegrationConnectionInput } from "../../../connected-accounts/integration-connection-input";

export const DialpadSourceConfig: React.FC = () => {
  return <IntegrationConnectionInput type="dialpad" />;
};
